export default {
	baseStyle: {
		borderRadius: '6px',
	},
}